import { css } from '@emotion/react';

import { MediaBP as MQ } from '../../../../styles/mediaQuery';
export const container = css`
  z-index: 0;
  height: 100%;
  &:hover {
    z-index: 10;
  }
`;

export const contentItemCard = () => css`
  margin-top: 16px;
  overflow: hidden;
  padding-right: 16px;
  ${MQ.MediaLg} {
    padding: 0;
    max-width: 1312px;
    margin: 16px auto 0;
  }
`;
